import axiosInstance from '@api/axiosInstance';
import ActionActivity from '@Components/General/Activity/Components/ActionActivity';
import ActivityNote from '@Components/General/Activity/Components/ActivityNote';
import ActivityTimeLine from '@Components/General/Activity/Components/ActivityTimeLine';
import AddActivity from '@Components/General/Activity/Components/AddActivity';
import useDialog from '@hooks/useDialog';
import { Card, CardContent, CardHeader } from '@mui/material';
import {
    useMutation,
    useQueryClient,
    useSuspenseQuery,
} from '@tanstack/react-query';
import { Await, useLoaderData, useParams } from '@tanstack/react-router';
import { contactActivitiesQueryOptions } from '@utils/queryOptions';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// TODO: focus color
// TODO: confirm delete

const ActivityCard = ({}) => {
    const { t } = useTranslation();
    const { contactId } = useParams({});
    const queryClient = useQueryClient();
    const dialog = useDialog();
    const [editActivity, setEditActivity] = useState(null);

    const { data: activities } = useSuspenseQuery(
        contactActivitiesQueryOptions(contactId),
    );

    const { mutateAsync: addActivity } = useMutation({
        mutationFn: note =>
            axiosInstance.post(`/contacts/${contactId}/activities`, { note }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['contactActivities', contactId],
            });
        },
    });

    const deleteActivityMutation = useMutation({
        mutationFn: id =>
            axiosInstance.delete(`/contacts/${contactId}/activities/${id}`),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['contactActivities', contactId],
            });
            dialog.close();
        },
    });

    const deleteActivity = id => {
        dialog.open({
            title: t('Delete Activity') + '?',
            content: t('prompts:content.deleteActivity'),
            onConfirm: () => id,
            confirmLabel: t('Delete'),
            confirmMutation: deleteActivityMutation,
            confirmButtonProps: {
                color: 'error',
            },
        });
    };

    const { mutate: updateActivity } = useMutation({
        mutationFn: note =>
            axiosInstance.patch(
                `/contacts/${contactId}/activities/${editActivity}`,
                {
                    note,
                },
            ),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['contactActivities', contactId],
            });
            setEditActivity(null);
        },
    });

    return (
        <Card
            elevation={0}
            sx={{
                mx: 0,
            }}
        >
            <CardHeader title={t('Activity')} />
            <CardContent
                sx={{
                    pt: 0,
                    '&: last-child': {
                        pb: 0,
                    },
                }}
            >
                <ActivityTimeLine>
                    <AddActivity onSubmit={addActivity} />
                    {activities.map(activity => (
                        <ActivityNote
                            key={activity.id}
                            activity={activity}
                            onEdit={() => setEditActivity(activity.id)}
                            onDelete={() => deleteActivity(activity.id)}
                            onCancel={() => setEditActivity(null)}
                            onUpdate={updateActivity}
                            isEditing={editActivity === activity.id}
                        />
                    ))}
                    {/* <ActionActivity /> */}
                </ActivityTimeLine>
            </CardContent>
        </Card>
    );
};

export default ActivityCard;
